import { Box } from "@mui/material"

// Tab label with a leading count pill in the primary colour. Used by the recipient Comments and
// Requested Information tabs. With a zero count the label is the plain string, so the tab looks
// unchanged. The count is an inline pill (not an MUI Badge) so it widens the tab instead of
// overflowing into the next one.
export function TabCountLabel({ label, count = 0, "data-cy": dataCy }) {
    if (!count) return label

    return (
        <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.75 }}>
            <Box
                component="span"
                data-cy={dataCy}
                sx={{
                    minWidth: 18,
                    height: 18,
                    px: 0.5,
                    borderRadius: 999,
                    bgcolor: "primary.lighter",
                    color: "primary.darker",
                    fontSize: 11,
                    fontWeight: 700,
                    lineHeight: "18px",
                    textAlign: "center",
                }}
            >
                {count}
            </Box>
            {label}
        </Box>
    )
}
